import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ColorSliderThumbDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle,
    getStateColorKey
} from "../../../../helpers/theme/state";
import {
    getElevationLayers
} from "../../../../helpers/theme/elevation";
import {
    getOpaqueColor,
    withAlpha,
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    disabled: {
        ...webStyle({
            cursor: "not-allowed"
        })
    },
    pressed: {
        ...webStyle({
            cursor: "grabbing"
        })
    },
    container: {
        position: "absolute",
        ...webStyle({
            cursor: "grab"
        })
    }
});

export const useStyles = ({
    currentMeasures,
    isFocusVisible,
    currentColors,
    shapeConfigs,
    orientation,
    pointerType,
    shadowAlpha,
    elevations,
    isDisabled,
    fillColor,
    isHovered,
    isPressed,
    radiuses,
    borders,
    colors,
    offset
}: ColorSliderThumbDynamicStyleType) => {
    const centerOffset = (currentMeasures.row - currentMeasures.thumbSize) / 2;

    const isRing = !isDisabled && (isPressed || isHovered && pointerType === "fine");

    const styles = {
        container: {
            zIndex: isPressed ? shapeConfigs.layers.raised + 1 : shapeConfigs.layers.raised,
            borderWidth: borders.focus + (isRing ? borders.line : 0),
            borderColor: currentColors.ringColor,
            height: currentMeasures.thumbSize,
            width: currentMeasures.thumbSize,
            borderRadius: radiuses.full,
            backgroundColor: fillColor
        } as Mutable<ViewStyle>
    };

    if(isDisabled) {
        Object.assign(styles.container, {
            backgroundColor: getOpaqueColor({
                color: colors.system.state.overlay.disabled.neutral,
                surface: colors.system.default.background
            }),
            borderColor: colors.system.state.border.disabled.neutral
        });
    }

    if(orientation === "vertical") {
        Object.assign(styles.container, {
            start: centerOffset,
            bottom: offset
        });
    }

    if(orientation === "horizontal") {
        Object.assign(styles.container, {
            top: centerOffset,
            start: offset
        });
    }

    if(!isDisabled) {
        Object.assign(styles.container, {
            boxShadow: [
                {
                    color: withAlpha({
                        color: colors.system.shadow,
                        alpha: shadowAlpha
                    }),
                    spreadDistance: borders.line,
                    offsetX: 0,
                    offsetY: 0
                },
                ...getElevationLayers({
                    level: isPressed ? "level2" : "level1",
                    shadowColor: colors.system.shadow,
                    shadowAlpha,
                    elevations
                })
            ]
        });
    }

    Object.assign(styles.container, getFocusRingStyle({
        colorKey: getStateColorKey({
            type: "primary"
        }),
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
